// extracted by mini-css-extract-plugin
export var dataCell = "_ql-2";
export var dataRow = "_ql-0";
export var headerRow = "_ql-1";